import { useContext } from 'react';
import { ObjectAccessContext } from '../Context';

export const useObjectAccessContext = () => {
  const reducer = useContext(ObjectAccessContext);

  return reducer;
};

export default useObjectAccessContext;